import React, { useState } from 'react';

const Home = () => {
  const [unit, setUnit] = useState('mm');
  const [height, setHeight] = useState('');
  const [width, setWidth] = useState('');
  const [depth, setDepth] = useState('');
  const [flapOverlap, setFlapOverlap] = useState('Quarter');
  const [showSizes, setShowSizes] = useState(false);

  const handleGenerateSizes = () => {
    if (height && width && depth) {
      setShowSizes(true);
    }
  };

  console.log('Units: ', unit);
  console.log('Size: ', height, width, depth);

  let gussetHeight = undefined;
  let gussetWidth = undefined;
  let bodyHeight = undefined;
  let bodyWidth = undefined;
  let bodyOverlapAdjust = 0;

  if(height && width && depth) {
    if(unit === 'mm') {
      switch(flapOverlap) {
        case 'Quarter':
          bodyOverlapAdjust = parseFloat(height) * 0.25;
          break;
        default:
        case 'Half':
          bodyOverlapAdjust = parseFloat(height) * 0.5;
          break;
        case 'Three Quarter':
          bodyOverlapAdjust = parseFloat(height) * 0.75;
          break;
        case 'Full':
          bodyOverlapAdjust = parseFloat(height);
          break;
      }
      // millimeters
      bodyHeight = (parseFloat(height) * 2) + (parseFloat(depth) * 2) + 25 + bodyOverlapAdjust;
      bodyWidth = parseFloat(width) + 13;
      gussetHeight = parseFloat(height) + 7;
      gussetWidth = parseFloat(depth) + 13;
    } else {
      switch(flapOverlap) {
        case 'Quarter':
          bodyOverlapAdjust = parseFloat(height) * 0.25;
          break;
        default:
        case 'Half':
          bodyOverlapAdjust = parseFloat(height) * 0.5;
          break;
        case 'Three Quarter':
          bodyOverlapAdjust = parseFloat(height) * 0.75;
          break;
        case 'Full':
          bodyOverlapAdjust = parseFloat(height);
          break;
      }
      // inches
      bodyHeight = (parseFloat(height) * 2) + (parseFloat(depth) * 2) + 1 + bodyOverlapAdjust;
      bodyWidth = parseFloat(width) + 0.5;
      gussetHeight = parseFloat(height) + 0.25;
      gussetWidth = parseFloat(depth) + 0.5;
    }
  }

  const unitLabel = unit === 'mm' ? 'mm' : 'inches';
  const inputCSS = {
    color: 'grey',
    padding: '2px',
    paddingLeft: '5px',
    margin: '2px',
    width: '75px',
    borderRadius: '4px',
    border: '1px solid #ccc'
  }
  return (
    <div id="homeBody">
      <h2 className="title">Pouch Size Calculator</h2>
      <p className="content">Use the tool below to calculate the size of the body and gussets for a custom pouch.</p>
      
      <p className="content">
        <div className="calculator-form">
          {/* Input Fields */}
          <div className="input-group" style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px'
          }}>
            <div className="input-row" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              <label style={{ minWidth: '120px' }}>
                Units:
              </label>
              <select value={unit} onChange={(e) => setUnit(e.target.value)} 
                style={{
                  color: 'grey',
                  padding: '2px',
                  margin: '2px',
                  width: '200px',
                  borderRadius: '4px',
                  border: '1px solid #ccc'
                }}>
                <option value="mm">Millimeters</option>
                <option value="inches">Inches</option>
              </select>
            </div>

            <div className="input-row" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              <label style={{ minWidth: '120px' }}>
                Height:
              </label>
              <input
                type="number"
                value={height}
                onChange={(e) => setHeight(e.target.value)}
                style={inputCSS}
              />
              <span style={{ color: 'white', fontSize: '18px' }}>{unitLabel}</span>
            </div>
            
            <div className="input-row" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              <label style={{ minWidth: '120px' }}>
                Width:
              </label>
              <input
                type="number"
                value={width}
                onChange={(e) => setWidth(e.target.value)}
                style={inputCSS}
              />
              <span style={{ color: 'white', fontSize: '18px' }}>{unitLabel}</span>
            </div>

            <div className="input-row" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              <label style={{ minWidth: '120px' }}>
                Depth:
              </label>
              <input
                type="number"
                value={depth}
                onChange={(e) => setDepth(e.target.value)}
                style={inputCSS}
              />
              <span style={{ color: 'white', fontSize: '18px' }}>{unitLabel}</span>
            </div>

            <div className="input-row" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              <label style={{ minWidth: '120px' }}>
                Flap Overlap:
              </label>
              <select value={flapOverlap} onChange={(e) => setFlapOverlap(e.target.value)}
                style={{
                  color: 'grey',
                  padding: '2px',
                  margin: '2px',
                  width: '150px',
                  borderRadius: '4px',
                  border: '1px solid #ccc'
                }}>
                <option value="Quarter">Quarter</option>
                <option value="Half">Half</option>
                <option value="Three Quarter">Three Quarter</option>
                <option value="Full">Full</option>
              </select>
            </div>


            <div className="input-row" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              <div style={{ minWidth: '120px' }}></div>
              <button 
                className="generate-button"
                onClick={handleGenerateSizes}
                disabled={!height || !width || !depth}
                style={{
                  color: 'grey',
                  padding: '2px',
                  margin: '2px',
                  width: '200px',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  height: '30px',
                  lineHeight: '24px'
                }}
              >
                Generate Sizes
              </button>
            </div>
          </div>

          {/* Results Display */}
          {showSizes && gussetHeight && gussetWidth && bodyHeight && bodyWidth && (
            <div className="results">
              <h3>Calculated Sizes</h3>
              
              <div className="part-sizes" style={{
                display: 'flex',
                gap: '20px',
                justifyContent: 'space-around',
                flexWrap: 'wrap'
              }}>
                <div className="body-size" style={{
                  flex: '1 1 300px',
                  textAlign: 'center',
                  minWidth: '250px'
                }}>
                  <h4>Body</h4>
                  <p>Height: {bodyHeight} {unitLabel}</p>
                  <p>Width: {bodyWidth} {unitLabel}</p>
                </div>

                <div className="gusset-size" style={{
                  flex: '1 1 300px',
                  textAlign: 'center',
                  minWidth: '250px'
                }}>
                  <h4>Gussets</h4>
                  <p>Height: {gussetHeight} {unitLabel}</p>
                  <p>Width: {gussetWidth} {unitLabel}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </p>
    </div>
  );
};

export default Home;